import { useEffect, useState } from 'react'

function useMediaQuery() {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1050px)')

    const handleMatch = event => {
      setMatches(event.matches)
    }

    handleMatch(mediaQuery) // 初始加载时执行一次

    mediaQuery.addEventListener('change', handleMatch) // 监听媒体查询结果变化

    return () => {
      mediaQuery.removeEventListener('change', handleMatch) // 组件卸载时移除事件监听
    }
  }, [])

  return matches
}

export default useMediaQuery
